import { useState } from "react";

export type Item = {
    id: string;
    title: string;
    description: string;
};

interface ItemProps {
    value: Item[];
    onChange: (value: Item[]) => void;
}

export default function Items({ value = [], onChange }: ItemProps) {
    return (
        <div className="flex flex-col gap-4">
            {value.map((item, index) => {
                return (
                    <div key={item.id} className="bg-white p-4 border border-gray-150 rounded-lg flex flex-col gap-3">
                        <Input
                            value={item.title}
                            placeholder="Title"
                            onChange={(v) => {
                                const newValue = [...value];
                                newValue[index].title = v;
                                onChange(newValue);
                            }}
                        />
                        <Input
                            value={item.description}
                            placeholder="Description"
                            onChange={(v) => {
                                const newValue = [...value];
                                newValue[index].description = v;
                                onChange(newValue);
                            }}
                        />
                        <div className="w-full flex justify-end">
                            <button
                                type="button"
                                className="flex justify-center items-center text-gray-500 border border-gray-150 hover:bg-gray-200 focus:ring-0 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm text-center h-8 w-8 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900"
                                onClick={() => {
                                    const newValue = [...value];
                                    newValue.splice(index, 1);
                                    onChange(newValue);
                                }}
                            >
                                <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z" />
                                </svg>
                            </button>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export function Input({ value, onChange, placeholder }: { value: string, placeholder?: string, onChange: (value: string) => void }) {
    const [v, setV] = useState(value);
    return (
        <input
            className="bg-white border text-gray-900 text-sm rounded-lg focus:outline-none border-gray-300 focus:border-blue-500 focus:ring-blue-500 focus:ring-1 focus:border w-full p-2.5"
            type="text"
            placeholder={placeholder}
            value={v} onChange={(e) => setV(e.target.value)} onBlur={() => onChange(v)}
        />
    );
};